import { render, staticRenderFns } from "./InvoicesTabContent.vue?vue&type=template&id=4c94027d&scoped=true"
import script from "./InvoicesTabContent.vue?vue&type=script&lang=js"
export * from "./InvoicesTabContent.vue?vue&type=script&lang=js"
import style0 from "./InvoicesTabContent.vue?vue&type=style&index=0&id=4c94027d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c94027d",
  null
  
)

export default component.exports